import React from "react";
import { Container } from "react-bootstrap";
import "./VehicleIntroBannerSection.css";


export default function VehicleIntroBannerSection({ vehicle }) {
  const {
    detailIntroBanner,
    detailIntroTitle,
    detailIntroParagraph1,
    detailIntroParagraph2
  } = vehicle;

  return (
    <section
      className="vehicle-intro-banner section-spacing"
      style={
        detailIntroBanner
          ? {
              backgroundImage: `linear-gradient(
                120deg,
                rgba(0, 0, 0, 0.78),
                rgba(0, 0, 0, 0.45)
              ), url(${detailIntroBanner})`
            }
          : undefined
      }
    >
      <Container fluid>
        <div className="vehicle-intro-banner__content">
          {detailIntroTitle && (
            <h2 className="vehicle-intro-banner__title">
              {detailIntroTitle}
            </h2>
          )}

          {detailIntroParagraph1 && (
            <p className="vehicle-intro-banner__paragraph">
              {detailIntroParagraph1}
            </p>
          )}

          {detailIntroParagraph2 && (
            <p className="vehicle-intro-banner__paragraph">
              {detailIntroParagraph2}
            </p>
          )}
        </div>
      </Container>
    </section>
  );
}
